import { render, staticRenderFns } from "./ScreenMenuCodigosBodega.vue?vue&type=template&id=79e154ab"
import script from "./ScreenMenuCodigosBodega.vue?vue&type=script&lang=js"
export * from "./ScreenMenuCodigosBodega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports